import { Component } from '@angular/core';
import { LoaderService } from "./loader.service";
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {

  public isMobile = Capacitor.isNativePlatform();
  constructor(
    public loaderService: LoaderService
  ) { }

}
